import React from "react";
import "./boton.css";

const estilosBoton = [
  "botonPrimarioSolido",
  "botonEliminarSolido",
  "botonVerSolido",
  "botonEditarSolido",
  "botonTransparente"
];

const Boton = ({ children, buttonStyle, onClick }) => {
  const checarEstiloBoton = estilosBoton.includes(buttonStyle)
    ? buttonStyle
    : estilosBoton[0];
  return (
    <div className="formulario-input">
      <button
        className={`boton ${checarEstiloBoton}`}
        type="submit"
        onClick={onClick}
      >
        {children}
      </button>
    </div>
  );
};

export default Boton;
